var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04918 1.79918C3.4008 1.44754 3.87773 1.25 4.375 1.25H11.875C12.0408 1.25 12.1997 1.31585 12.3169 1.43306L17.317 6.43306C17.4341 6.55026 17.5 6.70924 17.5 6.875V16.875C17.5 17.3722 17.3025 17.8493 16.9509 18.2009C16.5993 18.5525 16.1222 18.75 15.625 18.75H4.375C3.87771 18.75 3.4008 18.5525 3.04918 18.2009C2.69755 17.8493 2.5 17.3722 2.5 16.875V3.125C2.5 2.62773 2.69755 2.1508 3.04918 1.79918ZM10.2337 14.9274L10.3636 14.7975C10.5092 14.7025 10.6337 14.5779 10.7288 14.4324L13.0462 12.1149C13.2696 11.8915 13.3365 11.5555 13.2156 11.2635C13.0946 10.9716 12.8098 10.7812 12.4938 10.7812H10.9313V6.25C10.9313 5.55965 10.3716 5 9.68127 5C8.99091 5 8.43127 5.55965 8.43127 6.25V10.7812H6.86876C6.55277 10.7812 6.2679 10.9716 6.14699 11.2635C6.02606 11.5555 6.0929 11.8915 6.31634 12.1149L8.63379 14.4324C8.7288 14.5779 8.85334 14.7025 8.99889 14.7975L9.12884 14.9274C9.27535 15.074 9.47406 15.1562 9.68126 15.1562C9.88846 15.1562 10.0872 15.074 10.2337 14.9274Z",
    fill: "#135BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.7f533d2e73134bde53dd243f054760f3.svg";
export { ForwardRef as ReactComponent };